<h4 class="group-name" (click)="toggleFields()">{{ name }} <span class="fa" [ngClass]="toggleClass"></span></h4>
<div class="fields" *ngIf="showFields"><ng-content></ng-content></div>
